import { getDeviceIdFromSession, getPersonIdFromToken, getRegisteredDevice, isDeviceValidatedInSession, setDeviceIdInSession, setDeviceValidatedInSession, } from '@ibk/shared-auth';
import { clearTokens, ENV_VARS, persistor, selectAccessToken, selectRefreshToken, store } from '@ibk/shared-config';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
import { clearSessionFromBpo, setSessionFromBpo } from './bpoSession';
export const BPO_OPERATIONS = {
    home: '/home',
    nfse: '/vendas/servico/notas-fiscais/nova',
    pagar: '/financeiro/contas-a-pagar',
    receber: '/financeiro/contas-a-receber',
    beneficios: '/beneficios/nova-recarga',
    settings: '/configuracoes',
    support: '/suporte',
    services: '/cadastros/servicos',
};
export function isStandaloneBpo() {
    return ENV_VARS.VITE_BPO_STANDALONE === 'true';
}
export function getDomainOrigin(domain) {
    const value = domain === 'empresa' ? ENV_VARS.VITE_DOMINIO_EMPRESA_URL : ENV_VARS.VITE_DOMINIO_BPO_URL;
    if (!value)
        throw new Error('Domain origin is not configured');
    const url = new URL(value);
    if (url.origin !== value.replace(/\/$/, '') || url.username || url.password || url.search || url.hash)
        throw new Error('Invalid domain origin');
    if (url.protocol !== 'https:' && !(url.protocol === 'http:' && url.hostname === 'localhost'))
        throw new Error('HTTPS is required');
    return url.origin;
}
export async function transferSession(domain, companyId, operation) {
    const origin = getDomainOrigin(domain);
    const state = store.getState();
    const accessToken = selectAccessToken(state) || localStorageService.getItemSync(StorageKeys.AuthToken);
    const refreshToken = selectRefreshToken(state) || localStorageService.getItemSync(StorageKeys.AuthRefreshToken);
    const deviceId = getDeviceIdFromSession();
    if (!accessToken || !deviceId || !isDeviceValidatedInSession())
        throw new Error('Authenticated session required');
    const nonce = crypto.randomUUID();
    const frame = document.createElement('iframe');
    frame.hidden = true;
    frame.referrerPolicy = 'no-referrer';
    frame.src = `${origin}/session-transfer#${nonce}`;
    const destination = domain === 'bpo' ? '/bpo/clientes' : BPO_OPERATIONS[operation ?? 'home'];
    let sent = false;
    await new Promise((resolve, reject) => {
        const finish = (error) => {
            clearTimeout(timer);
            globalThis.removeEventListener('message', receive);
            frame.remove();
            if (error)
                reject(error);
            else
                resolve();
        };
        const receive = (event) => {
            if (event.origin !== origin || event.source !== frame.contentWindow || event.data?.nonce !== nonce)
                return;
            if (event.data.type === 'ibk-domain-ready' && !sent) {
                sent = true;
                const payload = {
                    type: 'ibk-domain-session',
                    nonce,
                    accessToken,
                    refreshToken: refreshToken ?? undefined,
                    deviceId,
                    companyId,
                    operation,
                };
                frame.contentWindow?.postMessage(payload, origin);
            }
            else if (event.data.type === 'ibk-domain-complete')
                finish();
            else if (event.data.type === 'ibk-domain-failed')
                finish(new Error('Session transfer failed'));
        };
        const timer = setTimeout(() => finish(new Error('Session transfer timed out')), 30000);
        globalThis.addEventListener('message', receive);
        document.body.appendChild(frame);
    });
    localStorageService.removeItem(StorageKeys.AuthToken);
    localStorageService.removeItem(StorageKeys.AuthRefreshToken);
    store.dispatch(clearTokens());
    await persistor.flush();
    globalThis.location.assign(`${origin}${destination}#${nonce}`);
}
export const DOMAIN_RECEIPT_KEY = 'ibk-domain-receipt';
export async function restoreTransferredDevice() {
    const nonce = globalThis.location.hash.slice(1);
    if (!/^[a-f0-9-]{36}$/.test(nonce))
        return;
    const raw = localStorage.getItem(DOMAIN_RECEIPT_KEY);
    if (!raw)
        return;
    clearSessionFromBpo();
    localStorage.removeItem(DOMAIN_RECEIPT_KEY);
    globalThis.history.replaceState(null, '', globalThis.location.pathname + globalThis.location.search);
    try {
        const receipt = JSON.parse(raw);
        const token = localStorageService.getItemSync(StorageKeys.AuthToken);
        if (receipt.nonce !== nonce || receipt.expiresAt < Date.now() || !token)
            return;
        const personId = getPersonIdFromToken(token);
        if (!personId || personId !== receipt.personId)
            return;
        const device = await getRegisteredDevice(personId);
        if (!device?.validated || device.deviceId !== receipt.deviceId)
            return;
        setDeviceIdInSession(device.deviceId);
        setDeviceValidatedInSession(true);
        if (receipt.fromBpo === true && !isStandaloneBpo())
            setSessionFromBpo();
    }
    catch {
    }
}
